import { createSelector } from '@reduxjs/toolkit';

import { extractAccessories } from 'shared/product_tabs/tab_accessories/slice/extractors';
import { isPasteProduct } from 'shared/product_tabs/tab_accessories/slice/utils';

export const selectAccessoriesInfo = (state) => state.accessories?.accessoriesInfoList;
export const selectUserAccessories = (state) => state.accessories?.accessories;
export const selectAccessoriesToDestroy = (state) => state.accessories?.accessoriesToDestroy;

export const selectAccessoryProducts = createSelector(
  [selectAccessoriesInfo],
  (accessoriesInfoList) => ({
    paste_products: accessoriesInfoList ? accessoriesInfoList.filter((accessory) => isPasteProduct(accessory)) : [],
    other_products: accessoriesInfoList ? accessoriesInfoList.filter((accessory) => !isPasteProduct(accessory)) : [],
  })
);

export const selectUserAccessoriesDetail = createSelector(
  [selectUserAccessories, selectAccessoriesInfo],
  (accessories, accessoriesInfoList) => {
    const user_accessories = accessories && accessories.length ? accessories : [];
    return user_accessories.map((accessory) => {
      const accessoryInfo = accessoriesInfoList.find((info) => info.id === accessory.product_id);
      const product_title = accessoryInfo.selected_variant.sku && accessoryInfo.selected_variant.sku !== '' ? accessoryInfo.selected_variant.sku : accessoryInfo.name;

      return {
        ...accessory,
        product_title,
        item_total: accessoryInfo.selected_variant.price * accessory.quantity,
      };
    });
  }
);

export const selectAccessoriesDataForCart = createSelector(
  [selectUserAccessories, selectAccessoriesInfo, selectAccessoriesToDestroy],
  (accessories, accessoriesInfoList, toDestroy) => {
    const accessoriesDataForForms = accessories && accessories.length ? { accessories } : null;
    const accessoriesToDestroy = toDestroy && toDestroy.length ? toDestroy : [];

    return {
      accessoriesDataForForms,
      accessoriesToDestroy,
      accessoriesProps: extractAccessories({ accessories, accessoriesInfoList }),
    };
  }
);
